import { useCallback, useEffect, useMemo, useState } from "react";
import { getVar } from "../../../../http/api/VarAPI";
import { getProduct } from "../../../../http/api/ProductAPI";
import { searchShopInfoList } from "../../../../http/api/CustomerAPI";

/**
 * 明細選択オプション　管理用フック
 */
export const useSelectOptions = () => {

  
  const [shops, setShops] = useState([]);
  const [products, setProducts] = useState([]);  
  const [origins, setOrigins] = useState([]);
  const [ranks, setRanks] = useState([]);
  const [productClasses, setProductClasses] = useState([]);
  const [packings, setPackings] = useState([]);  
  const [weightUnits, setWeightUnits] = useState([]);
  const [orderingUnits, setOrderingUnits] = useState([]);

  const searchShops = useCallback(async (csvCustomerGroupId) => {
    const shopRes = await searchShopInfoList({csvCustomerGroupId});
    setShops(shopRes.listShopInfo);
  }, []);

  const searchProducts = useCallback(async () => {
    const productRes = await getProduct({});
    setProducts(productRes.listProductInfo);
  }, []);
  
  const searchOrigins = useCallback(async () => {
    const originRes = await getVar({varDiv: 1});

    setOrigins(
      originRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          originId: varInfo.varCd,
          originName: varInfo.varValue1
        }))
    );
  }, []);

  const searchRanks = useCallback(async () => {
    const rankRes = await getVar({varDiv: 3});
    
    setRanks(
      rankRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          rankId: varInfo.varCd,
          rankName: varInfo.varValue1
        })
      )
    );
  }, []);

  const searchProductClasses = useCallback(async () => {
    const productClassRes = await getVar({varDiv: 2});
    setProductClasses(
      productClassRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          productClassId: varInfo.varCd,
          productClassName: varInfo.varValue1
        }))
    );
  }, []);

  const searchPackings = useCallback(async () => {
    const packingRes = await getVar({varDiv: 4});
    setPackings(
      packingRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          packingId: varInfo.varCd,
          packingName: varInfo.varValue1
        }))
    );
  }, []);

  const searchWeightUnits = useCallback(async () => {
    const weightUnitRes = await getVar({varDiv: 5});
    setWeightUnits(
      weightUnitRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          weightUnitId: varInfo.varCd,
          weightUnitName: varInfo.varValue1
        }))
    );
  }, []);

  const searchOrderingUnits = useCallback(async () => {
    const orderingUnitRes = await getVar({varDiv: 7});
    setOrderingUnits(
      orderingUnitRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          orderingUnitId: varInfo.varCd,
          orderingUnitName: varInfo.varValue1
        }))
    );
  }, []);

  useEffect(() => {
    (async () => {
      await searchProducts();
      await searchOrigins();
      await searchRanks();
      await searchProductClasses();
      await searchPackings();
      await searchWeightUnits();
      await searchOrderingUnits();
    })();
  },
  [
    searchProducts,
    searchOrigins, 
    searchRanks, 
    searchProductClasses, 
    searchPackings, 
    searchWeightUnits, 
    searchOrderingUnits
  ]);


  return useMemo(() => ({
    shops, searchShops, products, origins, ranks, productClasses, packings, weightUnits, orderingUnits
  }), [shops, products, origins, ranks, productClasses, packings, weightUnits, orderingUnits]);

}


